import { Component, Input, OnInit } from '@angular/core'
import { FormGroup, FormControl, Validators,  FormGroupDirective } from '@angular/forms'

@Component({
    selector: 'app-form-toggle-switch',
    templateUrl: 'form-toggle-switch.html'
})
export class FormToggleSwitchComponent implements OnInit {

    @Input() label: string = ''
    @Input() fieldId: string = 'toggle-switch'
    @Input() value: string = ''
    @Input() checked: boolean = false
    @Input() required: boolean = false
    @Input() modifierClassname?: string

    form: FormGroup

    constructor(private rootFormGroup: FormGroupDirective) {}

    ngOnInit(): void {
        this.form = this.rootFormGroup.control;

        this.form.addControl(
            this.fieldId, 
            new FormControl(this.checked, this.required ? Validators.requiredTrue : null)
        )
    }
}
